import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useI18n } from "../../i18n";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  const { t, currency, fmtCcy } = useI18n();
  const FAQS = [1, 2, 3, 4, 5, 6, 7, 8].map((i) => ({
    q: t(`faq${i}_q`, { comp: fmtCcy(999), full: fmtCcy(currency.mrp) }),
    a: t(`faq${i}_a`, { comp: fmtCcy(999), full: fmtCcy(currency.mrp) }),
  }));
  return (
    <section id="faq" className="relative py-16 sm:py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-xl">
          <span className="chip">{t("faq_chip")}</span>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl mt-5 leading-[1.05]">
            {t("faq_h1_a")} <span className="text-[color:var(--gold)]">{t("faq_h1_b")}</span>
          </h2>
        </div>

        <div className="mt-8 sm:mt-10 border border-[#23232a] rounded-2xl divide-y divide-[#23232a] overflow-hidden">
          {FAQS.map((f, i) => {
            const isOpen = i === open;
            return (
              <div key={i} data-testid={`faq-${i}`}>
                <button onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between text-left px-4 sm:px-6 py-4 sm:py-5 hover:bg-[rgba(231,180,59,.03)] transition-colors gap-4">
                  <span className="font-display font-semibold text-[14px] sm:text-base pr-2 sm:pr-6">{f.q}</span>
                  <span className="w-7 h-7 sm:w-8 sm:h-8 rounded-full grid place-items-center border border-[#23232a] shrink-0">
                    {isOpen ? <Minus className="w-3.5 h-3.5" /> : <Plus className="w-3.5 h-3.5" />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 sm:px-6 pb-5 sm:pb-6 text-[13px] sm:text-sm text-[color:var(--ink-dim)] leading-relaxed">{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
